import Vue from 'vue'
import Router from 'vue-router'
const index = resolve => require(['@/components/index'], resolve)

Vue.use(Router)

let router = new Router({
  routes: [{
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: index
    }
    
  ],
  //路由切换页面始终回到最顶部
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})
router.beforeEach((to, from, next) => {
  // 判断是否为着陆页
  if (navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 && !sessionStorage.getItem('landingUrl')) {
    sessionStorage.setItem('landingUrl', location.href)
  }
  next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js